import React from "react";
import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ModelMiniature from "../components/models/ModelMiniature";
import { getDesignById } from "../services/designService";
import { Context } from "../App";
import { resolveAuthorName } from "../utils/modelPreview";
import Header from "../components/layout/Header";

export default function ViewDesign() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { deconnect } = React.useContext(Context);

    const [design, setDesign] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState("");

    React.useEffect(() => {
        let active = true;

        const run = async () => {
            try {
                const data = await getDesignById(id);
                if (!active) return;
                setDesign(data);
            } catch (e) {
                if (!active) return;
                if (e.message === "SESSION_EXPIRED") {
                    alert("Votre session a expiré. Veuillez vous reconnecter.");
                    deconnect();
                    return;
                }
                setError("Impossible de charger ce design.");
            } finally {
                if (active) setLoading(false);
            }
        };

        run();
        return () => {
            active = false;
        };
    }, [id, deconnect]);

    if (loading) {
        return (
            <Box sx={{ p: 4, display: "flex", justifyContent: "center" }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error || !design) {
        return (
            <Box sx={{ p: 3 }}>
                <Alert severity="error">{error || "Design introuvable."}</Alert>
            </Box>
        );
    }

    return (
        <div>
            <Header title="Visualisation du design" />

            <Box sx={{ p: 3 }}>
                <Typography variant="h4" gutterBottom>{design.title}</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 1.5 }}>
                    {design.description || "Aucune description"}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Auteur: {resolveAuthorName(design.autor)} | Date: {design.updatedAt ? new Date(design.updatedAt).toLocaleString() : "-"}
                </Typography>

                <ModelMiniature model={design} fit />

                <Box sx={{ mt: 3, display: "flex", gap: 1 }}>
                    <Button variant="outlined" onClick={() => navigate("/design")}>Retour</Button>
                    <Button variant="contained" onClick={() => navigate(`/design/${design._id}/edit`)}>Editer</Button>
                    <Button variant="contained" color="secondary" onClick={() => alert("Action publier à implémenter plus tard.")}>
                        Publier
                    </Button>
                </Box>
            </Box>
        </div>
    );
}
